import React, { useState } from 'react';
import { Typography, Button, Box, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomAlert from '../userlocationcomponents/CustomAlert';
import { useNavigate } from 'react-router-dom';

const AssetFooter = ({
  onPreviousClick,
  onNextClick,
  onAuthorizeClick,
  handlCancelClick,
  handlSubmitClick,
  handlConvertToAssetClick,
  handleRejectClick,
  showAuthorize,
  showNext,
  showCancel,
  showSubmit,
  showReject,
  showConvertToAsset,
  previous,
  nextButtonTitle,
  showSave,
  saveClick,
  cancelButtonName,
  continueButtonName,
  authorizeButton,
  enableAuthorizeButton,
  enableRejectButton,
  enableConvetToAssetButton,
  enableSubmitButton,
  continueNext,
  continueButtonTitle,
  onContinueClick,
  dataChanged,
  isVendorLogin,
  showDownload,
  handleDownloadClick
}) => {
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const navigate = useNavigate();
  const handleCancelClick = ( ) => {
    if (dataChanged) {
      setShowCancelDialog(true);
    } else {
      setShowCancelDialog(false);
      if (!isVendorLogin) {
        navigate('/testingcommission')
      } else if (isVendorLogin) {
        navigate('/VendorDashboard')
      }
    }
  };

  const handleCloseCancelDialog = () => {
    setShowCancelDialog(false);
  };

  const handleConfirmCancel = () => {
    setShowCancelDialog(false);
    if (handlCancelClick) {
      handlCancelClick();
    }
  };

  return (
    <>
      <Box pt={{ xs: 3, md: 8 }} sx={{ display: 'flex', justifyContent: 'space-between' }} flexWrap={'wrap'}>
        {previous && (
          <Box>
            <IconButton aria-label="previous" onClick={onPreviousClick}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="labelSm" color="text.primary">
              {continueButtonName}
            </Typography>
          </Box>
        )}

        <Box sx={{ display: 'inline-flex', gap: 2 }}>
          {showCancel && <Button variant="outlined" onClick={handleCancelClick}>{cancelButtonName}</Button>}
          {showDownload && (
            <Button variant="contained" onClick={handleDownloadClick}>Download</Button>
          )}
             {showSave && <Button variant="contained" onClick={saveClick}>Save</Button>}
          {showSubmit && <Button variant="contained" onClick={handlSubmitClick} disabled={enableSubmitButton}>Submit</Button>}
          {showAuthorize && (
            <Button variant="contained" disabled={enableAuthorizeButton} onClick={onAuthorizeClick}>
              Authorize
            </Button>
          )}
          {showNext && (
            <Button variant="contained" onClick={onNextClick}>
              {nextButtonTitle}
            </Button>
          )}
          {continueNext && (
            <Button variant="contained" onClick={onContinueClick}>
              {continueButtonTitle}
            </Button>
          )}
       
          {showReject && (
            <Button variant="contained" disabled={enableRejectButton} onClick={handleRejectClick}>Reject</Button>
          )}
          {showConvertToAsset && (
            <Button variant="contained" disabled={enableConvetToAssetButton} onClick={handlConvertToAssetClick}>Convert To Asset</Button>
          )}
        </Box>
      </Box>
      <CustomAlert
        open={showCancelDialog}
        onClose={handleCloseCancelDialog}
        onConfirm={handleConfirmCancel}
        content={`Record(s) not Saved/Updated. Do you want to continue?`}
        confirmBtn={'Yes'}
        cancelBtn={'No'}
      />
    </>
  );
};

export default AssetFooter;
